import { useQuery } from "react-query";
import qs from "qs";
import URL from "core/resources/urls";
import http from "infra/http";
import { RdoDetailChartParams } from "../partials/diario/rdoDetailChartParams";
import { RdoRitmoDiarioResponse } from "../partials/diario/rdoRitmoDiario.types";

type Params = {
  params?: RdoDetailChartParams | null;
  enabled?: boolean;
};

export function useGetRdoRitmoDiario({ params, enabled = true }: Params = {}) {
  const canFetch =
    enabled &&
    !!params?.UnidadeId &&
    !!params?.SafraId &&
    !!params?.safraPeriodoId &&
    !!params?.operacaoClasseId;

  return useQuery(
    [URL.RELATORIO.DIARIO_OPERACOES_RITMO_DIARIO, params],
    async (): Promise<RdoRitmoDiarioResponse> => {
      const { data } = await http.get<RdoRitmoDiarioResponse>(
        URL.RELATORIO.DIARIO_OPERACOES_RITMO_DIARIO,
        {
          params,
          paramsSerializer: (p) => qs.stringify(p, { indices: false }),
          headers: { "api-version": "1.0" },
        }
      );
      return data;
    },
    { enabled: canFetch }
  );
}
